const clearPagingAndSortingState = (state, {
  currentPage = 1,
  sortBy = null,
  sortDesc = true,
  itemsPerPage = 10
}) => {
  state.paging.currentPage = currentPage
  state.paging.sortBy = sortBy
  state.paging.sortDesc = sortDesc
  state.paging.itemsPerPage = itemsPerPage
}

export default clearPagingAndSortingState
